import { IconComponent } from './types';

const PlusIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path stroke="currentColor" d="M5.167 0v10M0 4.833h10" />
  </svg>
);
export default PlusIcon;
